export enum ColumnField {
  CLUB_ID = "clubId",
  CLUB_NAME = "clubName",
  LICENCE_COUNT = "licenceCount",
  TOTAL_PRICE = "totalPrice",
}
